export const ACTIVE_ORGANIZATION_STORAGE_KEY = 'activeOrganizationId';

export const ACTIVE_ORGANIZATION_QUERY_PARAM = 'organizationId';

export const getActiveOrganizationId = (): string | undefined =>
  window?.sessionStorage.getItem(ACTIVE_ORGANIZATION_STORAGE_KEY) ?? undefined;

export const withActiveOrganizationId = (
  to: string,
  organizationId: string | undefined,
): string => {
  if (!organizationId) return to;

  const [pathAndQuery, hash] = to.split('#');
  const separator = pathAndQuery.includes('?') ? '&' : '?';
  const next = `${pathAndQuery}${separator}${ACTIVE_ORGANIZATION_QUERY_PARAM}=${encodeURIComponent(
    organizationId,
  )}`;

  return hash === undefined ? next : `${next}#${hash}`;
};
